import "./route-seo.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://visgroup.co.uk";
const DEFAULT_DESCRIPTION = "VIS Ventilation Industrial Systems Ltd provides HVAC installation, products, services, and project support from Northampton, United Kingdom.";

const ROUTE_METADATA = {
    "/": {
        title: "VIS GROUP | HVAC Specialists",
        description: DEFAULT_DESCRIPTION,
        canonicalPath: "/"
    },
    "/projects": {
        title: "Projects | VIS GROUP",
        description: "Recent ventilation and industrial systems project work delivered by VIS Ventilation Industrial Systems Ltd.",
        canonicalPath: "/projects"
    },
    "/products": {
        title: "Products | VIS GROUP",
        description: "Explore ductwork, bends, flanges, offsets, and related ventilation products from VIS Ventilation Industrial Systems Ltd.",
        canonicalPath: "/products"
    },
    "/services": {
        title: "Services | VIS GROUP",
        description: "Installation, supply, and end-to-end ventilation contracting services from VIS Ventilation Industrial Systems Ltd.",
        canonicalPath: "/services"
    },
    "/career": {
        title: "Career | VIS GROUP",
        description: "Career information and contact details for opportunities with VIS Ventilation Industrial Systems Ltd.",
        canonicalPath: "/career"
    },
    "/about": {
        title: "About | VIS GROUP",
        description: "Learn more about VIS Ventilation Industrial Systems Ltd and its approach to ventilation and air quality projects.",
        canonicalPath: "/about"
    },
    "/contact": {
        title: "Contact | VIS GROUP",
        description: "Contact VIS Ventilation Industrial Systems Ltd in Northampton by phone, email, or web form.",
        canonicalPath: "/contact"
    },
    "/legal-notice": {
        title: "Legal Notice | VIS Ventilation Industrial Systems Ltd",
        description: "Company and website contact details for VIS Ventilation Industrial Systems Ltd and visgroup.co.uk.",
        canonicalPath: "/legal-notice"
    },
    "/data-protection": {
        title: "Data Protection | VIS Ventilation Industrial Systems Ltd",
        description: "Privacy notice for visgroup.co.uk covering the contact form, AWS submission flow, and Google reCAPTCHA.",
        canonicalPath: "/data-protection"
    }
};

const getOrCreateMetaTag = (name) => {
    let tag = document.querySelector(`meta[name="${name}"]`);

    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
    }

    return tag;
};

const getOrCreateCanonicalLink = () => {
    let tag = document.querySelector("link[rel='canonical']");

    if (!tag) {
        tag = document.createElement("link");
        tag.setAttribute("rel", "canonical");
        document.head.appendChild(tag);
    }

    return tag;
};

const RouteSeo = () => {
    const location = useLocation();

    useEffect(() => {
        const metadata = ROUTE_METADATA[location.pathname] || {
            title: "VIS GROUP",
            description: DEFAULT_DESCRIPTION,
            canonicalPath: location.pathname || "/"
        };

        document.title = metadata.title;
        getOrCreateMetaTag("description").setAttribute("content", metadata.description);
        getOrCreateMetaTag("robots").setAttribute("content", "index,follow");
        getOrCreateCanonicalLink().setAttribute("href", `${SITE_ORIGIN}${metadata.canonicalPath}`);
    }, [location.pathname]);

    return null;
};

export default RouteSeo;
